import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Chat } from './chat.component';
import { PageWrapper } from '../../../components';
import { ChatContext } from '../contexts/chat.context';
export const ChatContainer = ({ children, chatProps }) => {
    const { isEnabled } = useContext(ChatContext);
    return (_jsxs("div", { className: 'flex h-full', children: [_jsx(PageWrapper, { children: children }), isEnabled && _jsx(Chat, { conversationKey: chatProps.conversationKey, systemPrompt: chatProps.systemPrompt })] }));
};
